import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [31, 31, 31, 31, 17],
  [22, 22, 22, 31, 17],
  [31, 31, 22, 31, 17],
  [23, 31, 22, 31, 17],
  [31, 22, 22, 31, 23],
];
const landscapeLayer2 = [
  [0, 0, 0, 0, 19],
  [1, 13, 0, 0, 50],
  [0, 0, 0, 0, 14],
  [39, 0, 13, 0, 14],
  [0, 0, 0, 0, 0],
];
const landscapeLayer3 = [
  [0, 0, 0, 0, 38],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 8, 0, 0, 0],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
